<script>
import {classify} from '../data'
import {getLibrayBannerByModuleApi} from '../../../api/technology'
import qs from 'qs'

export default {
  name: 'TechnologySecondTab',
  props: {
    value: {
      type: String | Number,
      required: true
    },
    firstClassify: {
      type: String | Number,
      required: true
    },
    isHaveImage: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      classify,
      tags: [],
      bannerCode: '',
      imageEntranceList: []
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    getImageUrl() {
      return (image) => {
        if (image.pictureMaterial && image.pictureMaterial.url) return image.pictureMaterial.url
        else if (image.materialDetail && image.materialDetail.materialThumbnail) return image.materialDetail.materialThumbnail
        return ''
      }
    },
    isShowSwiper() {
      return this.imageEntranceList && this.imageEntranceList.length
    },
    getFunctionName() {
      return (image) => {
        if (!image.linkUrl) return
        const urlParamsStr = image.linkUrl.split('?')[1]
        const urlParams = qs.parse(urlParamsStr)
        const fileId = urlParams.fileId
        const entrance = urlParams.entrance
        if (!entrance) return
        if (image.linkUrl.indexOf('technologyFCSW') > -1) return `房颤问卷-金刚位banner-${entrance}`
        else if (image.linkUrl.indexOf('carto30h5') > -1) return `carto30h5-金刚位banner-${entrance}`
        else return `新技术-金刚位banner-${fileId}-${entrance}`
      }
    }
  },
  watch: {
    firstClassify: {
      handler(val) {
        this.classify.forEach(item => {
          if (item.value === val) {
            this.tags = item.children
            this.bannerCode = item.bannerCode
            this.getLibrayBanner()
            this.$forceUpdate()
          }
        })
      }
    }
  },
  methods: {
    async getLibrayBanner() {
      const res = await getLibrayBannerByModuleApi(this.bannerCode)
      if (res.data && res.data.list && res.data.list.length) {
        this.imageEntranceList = res.data.list.filter(item => item.state === '1')
        this.$emit('update:isHaveImage', true)
      } else {
        this.imageEntranceList = []
        this.$emit('update:isHaveImage', false)
      }
    },
    handleClick(item) {
      if (this.$parent.$refs.TechnologyList.listState.loading) return
      this.$emit('input', item.value)
    },
    liveClick(image) {
      // 如果 linkUrl 不存在，直接返回
      if (!image.linkUrl) return
      try {
        const urlParamsStr = image.linkUrl.split('?')[1]
        const urlParams = qs.parse(urlParamsStr)
        const fileId = urlParams.fileId
        const entrance = urlParams.entrance
        if (!entrance) return
        const userId = this.userInfo.id
        sessionStorage.setItem('traceObj', JSON.stringify({
          functionUrl: image.linkUrl,
          note: urlParamsStr + `&userId=${userId}`
        }))
        window.sessionStorage.setItem('serviceId', fileId || '')
        window.sessionStorage.setItem('entrance', entrance)
        this.$router.push(image.linkUrl)
      } catch (error) {
        // 捕获并处理 URL 解析异常
        console.error('Invalid URL format:', error)
      }
    }
  }
}
</script>

<template>
  <div class="TechnologySecondTab">
    <div class="tabs">
      <div class="tabs-item" v-for="item in tags" :key="item.nanoid" v-track="{ functionName: `新技术-${item.label}`}"
           @click="handleClick(item)"
           :class="{ 'active': item.value === value }">
        <div class="tabs-item-label">{{ item && item.label }}</div>
      </div>
    </div>
    <van-swipe indicator-color="#ff7721" autoplay="2000" v-if="isShowSwiper">
      <van-swipe-item v-for="image in imageEntranceList" :key="image.id"
                      v-track="{ functionName: getFunctionName(image) }"
                      @click.stop="liveClick(image)">
        <img :src="getImageUrl(image)" class="image-entrance"/>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<style scoped lang="less">
.TechnologySecondTab {
  /deep/ .van-swipe {
    border-radius: 12px;
    margin-bottom: 10px;
  }

  /deep/ .van-swipe__indicators {
    bottom: 10px;
  }

  /deep/ .van-swipe__indicator:not(:last-child) {
    margin-right: 3px;
  }

  /deep/ .van-swipe__track {
    border-radius: 12px;
  }
}

.image-entrance {
  width: 100%;
  height: 80px;
  object-fit: cover;
  border-radius: 12px;
}

.tabs {
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .tabs-item {
    height: 22px;
    border-radius: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 12px;
    background: #FFFFFF;
    box-sizing: border-box;
    margin-right: 10px;
    margin-bottom: 15px;

    .tabs-item-label {
      font-family: Alibaba PuHuiTi 3.0;
      font-size: 12px;
      font-weight: normal;
      color: #898989;
      z-index: 0;
    }

    &.active {
      background: #FF6017;

      .tabs-item-label {
        color: #FFFFFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/technology/modules/TechnologySecondTab.vue